export const appRouterPaths = {
  home: '/',
  section: 'sections/:id'
};
